import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Auth from "ui/common/auth/Auth";
import Column from "../components/Column";

class AuthColumn extends React.Component {

	render() {
		return <Column id="auth" contentClassName="wcAuthContent" title={ this.props.configuration.interface.chat.title }>
			<Auth titleVisible={ false } />
		</Column>;
	}

}

AuthColumn.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration
	})
)(AuthColumn);